module.exports = __webpack_public_path__ + "static/media/nynaskomun.f3928472.png";